import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import { FirstReceiptInfo } from '../@types/digitalSignature/RefreshDigitalSignatureStatus'

type Store = {
  firstReceiptInfo?: FirstReceiptInfo | null
  setFirstReceiptInfo: (value: FirstReceiptInfo) => void
}

export const useFirstReceiptInfo = create<Store>()(
  devtools(
    (set) => ({
      firstReceiptInfo: null,
      setFirstReceiptInfo: (firstReceiptInfo) => set({ firstReceiptInfo }),
    }),
    { name: 'firstReceiptInfo' },
  ),
)
